module.exports = __webpack_public_path__ + "static/img/5.0955b897.png";